export default {
    path: "/wecode/connectorFlowMonitoring",
    auth: false,
    preload: false,
    key: "connectorFlowMonitoring",
    layout: "inner", // outer 一级菜单 inner 二级菜单
    component: () => import("./index")
  };
  